import {makeAdUrl} from '@frontend/helpers'
import {AdCommunicationButtons} from '@frontend/modules/public/ads/components/details/AdCommunicationButtons'
import {AdsListItemInfo} from '@frontend/modules/public/ads/components/list/AdsListItemInfo'
import {SellerInfo} from '@frontend/modules/public/seller_info/components/SellerInfo'
import clsx from 'clsx'
import type {MouseEvent} from 'react'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'
import type {AdPreviewDataForList} from '../../AdsModuleTypes'
import {AdsListItemImage} from './AdsListItemImage'

interface AdsListItemProps {
    ad: AdPreviewDataForList
    gridOrder?: number
    className?: string
    onAdDataChange: (ad: AdPreviewDataForList) => void
}

// Карточка предпросмотра объявления.
export function AdsListItem(props: AdsListItemProps) {

    const {
        ad,
        gridOrder = 0,
        className,
        onAdDataChange,
    } = props

    // Обработчик нажатия на карточку объявления.
    const onCardClick = useEventCallback((
        e: MouseEvent<HTMLElement>
    ) => {
        // Модальные окна карточки рендерятся в body, но их клики всплывают сюда через React.
        if (!e.currentTarget.contains(e.target as Node)) {
            return
        }
        // Check if the clicked element or any of its parents is an <a> or <button>
        let element: HTMLElement | null = e.target as HTMLElement | null
        while (element && element !== e.currentTarget) {
            if (
                element.tagName === 'A'
                || element.tagName === 'BUTTON'
                || element.hasAttribute('href')
                || typeof element.onclick === 'function'
            ) {
                return
            }
            element = element.parentElement
        }
        AnalyticsEventReporter.clickOnAdFromList(ad)
        window.open(makeAdUrl(ad.slugWithId, ad.categorySlugWithId), '_blank')
    })

    return (
        <Card
            className={clsx(
                'offered-item-card presentation-list cursor',
                ad.isPromoted ? 'promoted border border-2 border-orange' : null,
                className
            )}
            style={{
                order: gridOrder,
            }}
            onClick={onCardClick}
        >
            <CardBody
                className={clsx(
                    'p-2 d-flex gap-3 align-items-stretch justify-content-start',
                    'flex-column',
                    'flex-lg-row'
                )}
            >
                <AdsListItemImage ad={ad} />
                <AdsListItemInfo
                    ad={ad}
                    onAdDataChange={onAdDataChange}
                />
                <div className="offered-item-card-seller flex-shrink-0 d-none d-xl-flex flex-column gap-3">
                    <SellerInfo
                        seller={ad.seller}
                        layout="stacked"
                        noRegistrationDate
                        hideEmptyReviews
                        categoryType={ad.categoryType}
                        ratingBlockClassName="mt-0"
                    />
                    <AdCommunicationButtons<AdPreviewDataForList>
                        ad={ad}
                        condensed
                        onAdDataChange={onAdDataChange}
                        className="offered-item-card-actions d-flex flex-column gap-2"
                        buttonClassName="full-width flex-row-between"
                    />
                </div>
            </CardBody>
        </Card>
    )
}
